
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"150","height":"52","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 44.486l6.392-12.343 9.4-11.657m0 2.4L29.693 27m-16.919 6.171l11.28 4.115m11.655-9.6l-3.76 13.028v7.543l19.551-1.371m-15.79-7.543l11.655-1.029m-9.4-7.543l10.904-.685 9.399-2.4m.752 8.228L63.909 51m-9.4-14.4l6.016-1.714 9.4-1.715 2.631 4.8-10.758 6.515m2.11-1.715L80.453 46.2M74.06 30.086l9.4-4.8 10.527-2.743 1.504 5.828-9.4 4.8m2.256 1.029l15.039 3.771M75.94 22.543l9.4 13.371 3.007 6.515m13.16-28.115l3.007 12 5.64 9.6 3.76-.685 8.271-8.572m0 0l-4.887-17.143m4.887 17.143l2.256 9.257m8.648-1.714l-4.512-19.886 2.632-10.285h2.632l2.632 5.485 1.504 7.543 3.007-9.943L143.24 3h1.504L147 7.114v10.629l-3.008 19.2","stroke":"#fff","stroke-width":"6"}})])
          )
        }
      }
    